<!-- rota: /tanimlamalar/genel  (name: parametre-genel) -->
<template>
  <!--
    Cerceve ve yetkilendirme TABANDAN geliyor: v-app, baslik cubugu,
    yetkidialog, snackbar ve yukleniyor gostergesi sayfataban.vue icinde.
    Burada yalnizca sayfanin kendi icerigi var.
  -->
  <sayfataban :baslik="$t('Current-Account-General-Parameters')" :oncekiRota="oncekiRota" :durum="durum" ref="taban">

    <!-- Baslik cubugunun sagi. Bu slot KAPSAMLI DEGIL, yani kaydedebilir
         buradan okunamiyor; sayfa yetkiyi mounted'da tabandan alip kendi
         data'sina yaziyor. -->
    <template slot="baslikSag">
      <!-- color="" ZORUNLU: orijinal v-btn'de renk yoktu, bilesenin color
           varsayilani "primary"; verilmezse koyu baslik cubugunda buton
           maviye doner. flat varsayilani zaten true.
           Eski hidden="xs" silindi: .v-btn'in display: inline-flex'i
           tarayicinin [hidden]{display:none} kuralini ezdigi icin hicbir ise
           yaramiyordu. -->
      <!-- v-if: Save yetkisi olmayana buton hic cizilmiyor.
           :disabled AYRI bir kapi: Parameters/Get basariyla bitmeden
           kaydedilemez, cunku Kaydet butun GenelParametre nesnesini oldugu
           gibi POST ediyor ve yukleme basarisiz olursa nesne data()'daki bos
           iskelet olarak kalip mevcut parametreleri EZER. -->
      <kaydetbutonu v-if="kaydetYetkisi" :action="Kaydet" :disabled="!parametreYuklendi" color="">
        {{$t("save_button")}}
        <v-icon right dark>add_box</v-icon>
      </kaydetbutonu>
    </template>

    <v-form>
      <v-card flat>
        <v-layout row wrap>
          <v-card color="grey lighten-5" flat>
            <v-flex xs12 sm12>
            </v-flex>
            <v-container fluid>
              <v-layout row="" wrap="">
                <!-- <v-flex pa-1 xs12 sm4 md4>
                  <v-card>
                    <v-card color="grey lighten-5" flat="">
                      <v-card-actions>


                        <v-layout row="" wrap="">
                          <v-flex pa-1 xs12 sm12 md12>
                            <v-text-field :label="$t('VAT-Rate')" hide-details="" v-model="GenelParametre.KdvOran">
                            </v-text-field>
                            <v-text-field :label="$t('Arkman-Transfer-Group')" hide-details=""
                              v-model="GenelParametre.AktarimSure"></v-text-field>

                          </v-flex>
                        </v-layout>

                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex> -->

                <v-flex pa-1 xs12 sm12 md12>
                  <v-card>
                    <v-card color="grey lighten-5" flat="">
                      <v-card-actions>
                        <v-layout row="" wrap="">
                          <v-flex pa-1 xs12 sm12 md12>


                            <v-menu :close-on-content-click="true" v-model="menu" transition="scale-transition" offset-y
                              full-width :nudge-right="40" min-width="290px">
                              <v-text-field hide-details="" slot="activator" :label="$t('Date-of-Closing-Invoice')"
                                v-model="dateFormatted" append-icon="event" v-on:change="onChange" mask="##.##.####"
                                @blur="date = parseDate(dateFormatted)"></v-text-field>
                              <v-date-picker locale="tr" v-model="date" @input="dateFormatted = formatDate($event)"
                                no-title scrollable actions>
                                <v-spacer></v-spacer>
                              </v-date-picker>
                            </v-menu>


                            <v-text-field :label="$t('Number-of-Last-Receipt')" hide-details=""
                              v-model="GenelParametre.SonDekontNo"></v-text-field>


                          </v-flex>
                        </v-layout>

                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>

                <!-- <v-flex pa-1 xs12 sm4 md4>
                  <v-card>
                    <v-card color="grey lighten-5" flat="">
                      <v-card-actions>
                        <v-layout row="" wrap="">
                          <v-flex pa-1 xs12 sm12 md12>
                            <v-text-field :label="$t('Airline-Account-Group')" hide-details=""
                              v-model="GenelParametre.HavaYoluHesapGrubu"></v-text-field>
                          </v-flex>
                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex> -->


                <v-flex xs12 sm6 md4>
                  <v-switch :label="$t('Take-Receipt-to-Current-as-Single-Entry')" hide-details="" v-model="GenelParametre.DekontTek"
                    value="1"></v-switch>
                </v-flex>

                <v-flex xs12 sm6 md4>
                  <v-switch :label="$t('Open-Current-Cards-to-All-Companies')" hide-details=""
                    v-model="GenelParametre.TumSirketler" value="1"></v-switch>
                </v-flex>

                <v-flex xs12 sm6 md4>
                  <v-switch :label="$t('Make-All-Companies-Selected')" hide-details="" v-model="GenelParametre.TumSirketSecili"
                    value="1"></v-switch>
                </v-flex>

                <v-flex xs12 sm6 md4>
                  <v-switch label="Yeni Cari Kartlarda Tüm Şirketler İçin Kaydet Seçili Gelsin" hide-details=""
                    v-model="GenelParametre.CariTumSirketVarsayilan"></v-switch>
                </v-flex>



                <!-- <v-flex xs12 sm6 md4>
                  <v-switch :label="$t('Do-Not-Show-Main-Screen')" hide-details="" v-model="GenelParametre.AnaEkran" value="1" c>
                  </v-switch>
                </v-flex> -->


                <v-flex xs12 sm6 md4>
                  <v-switch :label="$t('Expense-Center-Obligatory')" hide-details="" v-model="GenelParametre.MasrafZorunlu"
                    value="1"></v-switch>
                </v-flex>



                <v-flex xs12 sm6 md4 v-if="PB=='TRY'">
                  <v-switch :label="$t('Data-Export-Special-Code-Obligatory')" hide-details=""
                    v-model="GenelParametre.DisAkatarimZorunlu" value="1"></v-switch>
                </v-flex>



                <v-flex xs12 sm6 md4>
                  <v-switch :label="$t('Activate-Starting-Date-of-Invoice-Closing')" hide-details=""
                    v-model="GenelParametre.FaturaKapamaAktif" value="1"></v-switch>
                </v-flex>
                    <v-flex xs12 sm6 md4>
                  <v-switch label="Next Muhasebe" hide-details=""
                    v-model="GenelParametre.NextMuhasebe" 
    ></v-switch>
                </v-flex>

               <!-- İade Cari Otomatik -->
<v-flex xs12 sm6 md4>
  <v-switch
    label="İade Cari Otomatik İşle"
    hide-details
    v-model="GenelParametre.IadeCariOtomatikIsle"
  ></v-switch>
</v-flex>


<v-flex xs12 sm12 md12 v-if="GenelParametre.IadeCariOtomatikIsle">
  <v-card flat class="pa-2" color="grey lighten-5">
    <v-layout row wrap>
      
      <v-flex xs12 sm6 md4>
        <v-switch
          label="İade Ana Satış Carisine Kaydet"
          hide-details
          v-model="GenelParametre.IadeKayitAnaCariye"
        ></v-switch>
      </v-flex>

      
      <!--<v-flex xs12 sm6 md4>
        <v-switch
          label="İade Cariye Ters Kapatma"
          hide-details
          v-model="GenelParametre.IadeKayitTersKapatma"
        ></v-switch>
      </v-flex>
-->
   
      <v-flex xs12 sm6 md2>
        <v-select
          :items="iadeKodYonleri"
          item-text="text"
          item-value="value"
          label="Cariye Kod Ekle Yönü"
          hide-details
          v-model="GenelParametre.IadeCariKodEkleYonu"
        ></v-select>
      </v-flex>

      
      <v-flex xs12 sm6 md2>
        <v-text-field
          label="Cariye Eklenecek Kod"
          hide-details
          v-model="GenelParametre.IadeCariEklenecekKod"
          placeholder="<IADE>"
          :counter="6"
          maxlength="6"
        ></v-text-field>
      </v-flex>
    </v-layout>
  </v-card>
</v-flex>




                <!-- <v-flex xs12 sm6 md4>
                  <v-switch label="Fatura Entegrasyonu" hide-details=""
                    v-model="GenelParametre.InvoiceIntegration3rd" 
    ></v-switch>
                </v-flex> -->
              </v-layout>
            </v-container>
          </v-card>
        </v-layout>
      </v-card>
    </v-form>
  </sayfataban>
</template>

<script>
  import sayfataban from "@/components/app/customcomp/sayfataban.vue"
  import kaydetbutonu from "@/components/app/customcomp/kaydetbutonu.vue"
  import tool from "@/components/app/coper/tools"

  export default {
    data() {
      return {
        PB:"TRY",
        date: null,
        dateFormatted: null,
        menu: false,
        drawer: null,
        baslik: '',
        GenelParametre: {
          KdvOran: '',
          HavaYoluHesapGrubu: '',
          SerbestFatura: '',
          SonDekontNo: '',
          DekontTek: '',
          TumSirketler: '',
          XmlPath: '',
          AktarimSure: '',
          XmlPathCari: '',
          XmlPathMaliyetFaturasi: '',
          XmlPathCariHareket: '',
          TumSirketSecili: '',
          FaturaEn: '',
          FaturaBoy: '',
          OzelBoy: '',
          Dot9Sifre: '',
          BolgeAyar: '',
          AnaEkran: '',
          CariAra: '',
          MasrafZorunlu: '',
          MerkezKur: '',
          SerbestFaturaDoviz: '',
          FaturaKapamaAktif: '',
          NextMuhasebe: false,
          FaturaKapamaTarih: '',
          CariAramaIc: '',
          DisAkatarimZorunlu: '',
          InvoiceIntegration3rd:false,
          IadeCariOtomatikIsle: false,
          IadeCariKodEkleYonu: 1, // 1: Önüne, 2: Arasına
          IadeCariEklenecekKod: '',
          IadeKayitAnaCariye: false,
          IadeKayitTersKapatma: false,
          CariTumSirketVarsayilan: false
        },
        iadeKodYonleri: [
  { text: "Önüne", value: 1 },
  { text: "Arkasına", value: 2 }
],

        // Snackbar ve yukleniyor gostergesi TABANDA; sayfa yalnizca bu
        // nesneyi dolduruyor. tool.NewSatatus() -> { show, text, loading }
        durum: tool.NewSatatus(),

        // Yetkisiz gelindiginde taban buraya dondurur. data()'da TANIMLI:
        // eskiden prevRoute hic tanimlanmamisti.
        oncekiRota: null,

        // Save yetkisi. Baslik cubugu slotu kapsamli olmadigi icin tabandan
        // mounted'da okunup buraya yaziliyor.
        kaydetYetkisi: false,

        // Parameters/Get basariyla tamamlandi mi. Yalnizca basari dalinda
        // true olur; hata dalinda ve yetki yoksa false kalir.
        parametreYuklendi: false
      }
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.oncekiRota = from.path
      })
    },
    components: {
      sayfataban,
      kaydetbutonu
    },
    mounted() {
      // Yetki kontrolu, uyari dialogu ve yonlendirme TABANDA. Taban ic ice
      // bir bilesen oldugu icin onun mounted'i BUNDAN ONCE calisir ve
      // pageScreenAuth senkron; yani yetki burada cozulmus durumda.
      var taban = this.$refs ? this.$refs.taban : null
      this.kaydetYetkisi = taban ? taban.kaydedebilir : false

      // Yetki yoksa hicbir istek atilmamali: taban kullaniciyi zaten
      // gonderiyor, bu arada sunucuya bos yere gidilmesin.
      if (!taban || !taban.sayfayiGorebilir) return

      var credentials = JSON.parse(window.localStorage.getItem('credentials'));
      this.PB = credentials.ParaBirimi

        var params = {}
        // tool.api_post: Authorization'in yani sira CariSirketNo /
        // CoperSirketNo / MuhasebeSirketNo basliklarini da gonderiyor. API
        // aktif sirketi YALNIZCA bu basliklardan okuyor (JWT sirket numarasi
        // tasimiyor); duz $http.post ile bu istekler sirket bilgisi olmadan
        // gidiyordu.
        tool.api_post(this, 'Parameters/Get', params).then((response) => {
          this.ParametreleriYerlestir(response.body)

          // EN SONDA: bayrak "GenelParametre eksiksiz dolu" demek. Yerlestirme
          // patlarsa false kalir ve buton pasif kalir.
          this.parametreYuklendi = true

        }, (response) => {
          // parametreYuklendi false kaliyor: buton pasif kalir.
          //
          // Mesaj this.text'e yaziliyordu ama snackbar text1'i gosteriyordu ve
          // text data()'da hic tanimli degildi: yukleme hatasinda kullaniciya
          // BOMBOS bir snackbar cikiyordu.
          this.durum.text = tool.HataMesajiCoz(response, this.$t.bind(this))
          this.durum.show = true
        })
    },
watch: {
  'GenelParametre.IadeKayitAnaCariye'(val) {
    if (val) this.GenelParametre.IadeKayitTersKapatma = false
  },
  'GenelParametre.IadeKayitTersKapatma'(val) {
    if (val) this.GenelParametre.IadeKayitAnaCariye = false
  },

  
  'GenelParametre.IadeCariOtomatikIsle'(val) {
    if (!val) {
      this.GenelParametre.IadeKayitAnaCariye = false
      this.GenelParametre.IadeKayitTersKapatma = false
    }
  }
},


    methods: {
      formatDate(date) {
        var str = date
        var n = str.search('.')
        if (n == 1) {
          return null
        } else {
          const [year, month, day] = date.split('-')
          return `${day}.${month}.${year}`
        }
      },
      parseDate(date) {
        if (!date) return null
        var str = date
        var n = str.search('-')
        var m = str.length
        if (n == 1) {
          const [month, day, year] = date.split('-')
          return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
        } else if (m == 8) {

        } else if (n == -1 && m != 8) {
          this.dateFormatted = getDateNow()
          this.date = getDateNow()
        } else {
          const [day, month, year] = date.split('.')
          return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
        }
      },
      /**
       * Parameters/Get ya da Parameters/Add'den donen parametre nesnesini
       * ekrana yerlestirir.
       *
       * Iki yol da AYNI son islemleri gerektiriyor (null alanlarin
       * varsayilana cekilmesi, tarihin ayristirilmasi); ayri ayri yazilirsa
       * zamanla ayrisirlar.
       */
      ParametreleriYerlestir(govde) {
        this.GenelParametre = govde

        // Varsayilanlar YUKLEMEDEN SONRA uygulaniyor. Eskiden mounted'in
        // basinda, data() iskeleti uzerinde yapiliyordi; hemen ardindan gelen
        // atama nesneyi bastan degistirdigi icin hicbir etkileri yoktu.
        // Sunucu bir alani null dondurdugunde asil isleyen yer burasi.
        if (this.GenelParametre.IadeCariOtomatikIsle == null) this.GenelParametre.IadeCariOtomatikIsle = false
        if (this.GenelParametre.IadeCariKodEkleYonu == null) this.GenelParametre.IadeCariKodEkleYonu = 1
        if (this.GenelParametre.IadeCariEklenecekKod == null) this.GenelParametre.IadeCariEklenecekKod = ''
        if (this.GenelParametre.IadeKayitAnaCariye == null) this.GenelParametre.IadeKayitAnaCariye = false
        if (this.GenelParametre.IadeKayitTersKapatma == null) this.GenelParametre.IadeKayitTersKapatma = false
        if (this.GenelParametre.CariTumSirketVarsayilan == null) this.GenelParametre.CariTumSirketVarsayilan = false

        // "0001-01-01" = tarih hic secilmemis. String()'e sarmak SART:
        // eskiden dogrudan .split cagriliyordu ve alan null gelirse yukleme
        // patliyor, bayrak acilmadigi icin buton da pasif kaliyordu.
        var bastarih = String(govde.FaturaKapamaTarih || '').split("T")
        if (bastarih[0] === '0001-01-01' || bastarih[0] === '') {
          this.GenelParametre.FaturaKapamaTarih = null
        } else {
          this.date = bastarih[0]
          this.dateFormatted = toDateformat(this.date)
        }
      },

      onChange: onChange,
      getDateNow: getDateNow,
      toDateformat: toDateformat,
      Kaydet: Kaydet
    },

  }

  function Kaydet() {
    this.GenelParametre.FaturaKapamaTarih = this.date
    var params = this.GenelParametre

    // Promise DONDURULUYOR: kaydetbutonu butonun kilidini bunun cozulmesine
    // gore aciyor.
    return tool.api_post(this, 'Parameters/Add', params).then((response) => {
      this.durum.text = this.$t(response.body.ResponseMessage)
      this.durum.show = true

      // Ekran artik GONDERDIGIMIZI degil, API'nin kayittan sonra DB'den geri
      // okudugunu gosteriyor. Yazilamayan bir alan kayittan hemen sonra eski
      // degerine donerek kendini belli ediyor.
      //
      // Status kontrolu ve varlik kontrolu: eski surum bir API bu alani hic
      // gondermez, o zaman ekran oldugu gibi kalir.
      if (response.body.Status === true && response.body.GenelParametre) {
        this.ParametreleriYerlestir(response.body.GenelParametre)
      }
    }, (response) => {
      // Iki dal da sabit 'Service Unavailable' yaziyordu; sunucunun gercek
      // aciklamasi kayboluyordu. HataMesajiCoz baglanti kopmasini (status 0)
      // kendisi ele aliyor, ayri dala gerek yok.
      this.durum.text = tool.HataMesajiCoz(response, this.$t.bind(this))
      this.durum.show = true
    })
  }



  function toDateformat(dateStr) {
    var parts = dateStr.split("-");
    return (parts[2] + '.' + parts[1] + '.' + parts[0]);
  }

  function onChange(v) {
    var c = v.length
    var a = v
    if (c == 8) {
      var b = a[4] + a[5] + a[6] + a[7] + '-' + a[2] + a[3] + '-' + a[0] + a[1]
      this.date = b
    } else {
      this.dateFormatted = null
    }
  }


  function getDateNow() {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0!
    var yyyy = today.getFullYear();

    if (dd < 10) {
      dd = '0' + dd
    }

    if (mm < 10) {
      mm = '0' + mm
    }
    today = dd + '-' + mm + '-' + yyyy
    return today
  }
</script>
<style>
</style>